
export default {
  name: "AnotationMessage",

  data: function () {
    return {
      messageFullMobile: false
    }
  },

  props: {
    message: {
      type: String,
      default: ""
    }
  },

  computed: {
    smallMessage: function () {
      return (this.message || "").split(" ").splice(0, 3).join(" ")
    }
  },

  methods: {
    changeMessageFullMobile: function () {
      this.messageFullMobile = true;
    }
  }
}
